import { useState } from 'react';
//import { initialProducts, initialCategories } from '../data/mockData';
import { useEffect } from 'react';
import API_BASE_URL from '../Config';


export function useProducts() {
  // Estados para gestión de productos
  //const [products, setProducts] = useState(initialProducts);
  //const [categories, setCategories] = useState(initialCategories);
  const buscarProductosDesdeBack = async (termino) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/productos/buscar?query=${encodeURIComponent(termino)}`);
      if (!response.ok) throw new Error('Error al buscar productos');

      const data = await response.json();

      const normalizados = data.map(p => ({
        id: p.id,
        name: p.nombre,
        price: p.precio,
        category: p.categoria?.nombre || 'Sin categoría',
      }));

      setProducts(normalizados);
    } catch (error) {
      console.error('❌ Error al buscar productos desde backend:', error);
    }
  };



  
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState(['Todos']);
  
  // Estados de filtrado y búsqueda
  const [selectedCategory, setSelectedCategory] = useState('Todos');
  const [searchTerm, setSearchTerm] = useState('');

  // Estados para formulario de productos
  const [newProduct, setNewProduct] = useState({
    name: '',
    price: 0,
    category: categories[1] || '',
  });
  
  const [editingProduct, setEditingProduct] = useState(null);
  const [addingCategory, setAddingCategory] = useState(false);
  const [tempCategoryName, setTempCategoryName] = useState('');

  // Estados para el carrito y pagos
  const [cart, setCart] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);

//este
useEffect(() => {
  const fetchProducts = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/productos`);
      if (!response.ok) throw new Error('Error al cargar productos');

      const data = await response.json();
      //console.log('📦 Productos originales:', data);

      // 🔧 Normalizar productos
      const normalized = data.map(p => ({
        id: p.id,
        name: p.nombre,
        price: p.precio,
        category: p.categoria?.nombre || 'Sin categoría', // 🔐 protegemos contra null
      }));

      //console.log('🧪 Productos normalizados:', normalized);

      setProducts(normalized);

      // Extraer categorías
      const uniqueCategories = ['Todos', ...new Set(data.map(p => p.categoria?.nombre || 'Sin categoría'))];
      setCategories(uniqueCategories);
    } catch (error) {
      console.error('❌ Error al obtener productos:', error);
    }
  };

  fetchProducts();
}, []);


//este




  

  // Filtrar productos según categoría y término de búsqueda
const filteredProducts = products.filter(product => {
  const matchesCategory =
    selectedCategory === 'Todos' || product.category === selectedCategory;

  const matchesSearch =
    typeof product.name === 'string' &&
    product.name.toLowerCase().includes(searchTerm.toLowerCase());

  return matchesCategory && matchesSearch;
});

  // Función para agregar nueva categoría
  const addNewCategory = (categoryName) => {
    const trimmedName = categoryName.trim();
    if (!trimmedName || categories.includes(trimmedName)) return null;
    
    setCategories(prev => [...prev, trimmedName]);
    setNewProduct(prev => ({
      ...prev,
      category: trimmedName
    }));
    setTempCategoryName('');
    setAddingCategory(false);
    
    return trimmedName;
  };

  // Función para agregar producto
  const addProduct = () => {
    if (!newProduct.name.trim() || newProduct.price <= 0) return;

    const product = {
      id: Date.now().toString(),
      name: newProduct.name.trim(),
      price: Number(newProduct.price),
      category: newProduct.category,
      createdAt: new Date().toISOString()
    };

    setProducts(prev => [...prev, product]);
    setNewProduct({
      name: '',
      price: 0,
      category: categories[1] || '',
    });
  };

  // Funciones para edición de productos
  const startEditProduct = (product) => {
    setEditingProduct({ ...product });
  };

  const saveEditedProduct = () => {
    if (!editingProduct) return;

    const updatedProducts = products.map(product => 
      product.id === editingProduct.id ? { 
        ...editingProduct, 
        updatedAt: new Date().toISOString() 
      } : product
    );
    
    setProducts(updatedProducts);
    
    // Actualizar también en el carrito si existe
    setCart(prev => prev.map(item => 
      item.id === editingProduct.id ? { ...item, ...editingProduct } : item
    ));
    
    setEditingProduct(null);
  };

  // Función para eliminar producto
  const deleteProduct = (id) => {
    setProducts(prev => prev.filter(product => product.id !== id));
    setCart(prev => prev.filter(item => item.id !== id));
  };

  // Funciones para gestión del carrito
  const addToCart = (product) => {
    setCart(prev => [...prev, { ...product, cartId: `${product.id}-${Date.now()}` }]);
  };

  const removeFromCart = (cartId) => {
    setCart(prev => prev.filter(item => item.cartId !== cartId));
  };

  const clearCart = () => {
    setCart([]);
  };

  // Funciones para procesamiento de pagos
  const processPayment = async () => {
    console.log('🚀 processPayment iniciado');
    setIsProcessingPayment(true);
    return await new Promise((resolve) => {
      setTimeout(() => {
        const isSuccess = paymentMethod === 'cash' || Math.random() > 0.3;
        console.log('🔚 processPayment finalizado - éxito:', isSuccess);
        setIsProcessingPayment(false);
        resolve(isSuccess);
      }, 1500);
    });
  };

  // Retornamos todos los estados y funciones necesarias
  return {
    // Estados de productos
    products,
    categories,
    selectedCategory,
    searchTerm,
    newProduct,
    editingProduct,
    filteredProducts,
    addingCategory,
    tempCategoryName,
    
    // Estados de carrito y pagos
    cart,
    paymentMethod,
    paymentStatus,
    showPaymentModal,
    isProcessingPayment,

    //buscador
    buscarProductosDesdeBack, // 👈 AGREGAR AQUÍ
    
    // Setters
    setSelectedCategory,
    setSearchTerm,
    setNewProduct,
    setEditingProduct,
    setAddingCategory,
    setTempCategoryName,
    setPaymentMethod,
    setShowPaymentModal,
    
    // Funciones de productos
    addProduct,
    startEditProduct,
    saveEditedProduct,
    deleteProduct,
    addNewCategory,
    
    // Funciones de carrito
    addToCart,
    removeFromCart,
    clearCart,
    
    // Funciones de pago
    processPayment,

    // Helpers
    cartTotal: cart.reduce((sum, product) => sum + product.price, 0),
    cartItemCount: cart.length,
    hasItemsInCart: cart.length > 0
  };
}
